import styles from '../../styles/pdfStyles';
import { Document, Image, Link, Page, Text, View } from '@react-pdf/renderer';
import { trimString } from '../../utils/converter';
import IntegritasLogo from '../../assets/logos/IntegritasLogo.png';
import SummaryPDF from './SummaryPDF';
import ValidationInfoPDF from './ValidationInfoPDF';
import FileDetailsPDF from './FileDetailsPDF';
import NftSectionPDF from './NftSectionPDF';
import BlockDetailsPDF from './BlockDetailsPDF';

import { BLOCK_EXPLORER_TXN_ID_URL } from '../../utils/config';

const DocumentPDF = ({
  reportData,
  blockHistory,
  // imageSrc
}) => {
  return (
    <Document
      style={styles.document}
      title={`Verification Report - ${reportData && trimString(reportData?.FILE_NAME)} - ${
        reportData?.VALIDATION_DATE
      }`}
    >
      {reportData.VALID !== '0' && (
        <>
          <Page style={styles.wholePage}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: 18,
                backgroundColor: '#C0C0C0', // TODO decide on color
              }}
            >
              <Text style={{ fontSize: 18, fontWeight: 'semibold', color: '#2E2E2E' }}>
                Verification Report
              </Text>

              <Image style={{ width: 120, height: 40 }} src={IntegritasLogo} />
            </View>
            <Text
              style={{
                padding: 12,
                paddingLeft: 16,
                fontSize: 12,
                fontWeight: 'semibold',
                backgroundColor: '#F2F2F2',
              }}
            >
              Report ID:
              <Link
                style={{ color: '#4F8EF7', textDecoration: 'underline' }}
                src={`${BLOCK_EXPLORER_TXN_ID_URL}/${reportData.TOKEN_TXPOW}`}
              >
                {trimString(reportData.TOKEN_ID)}
              </Link>
            </Text>
            <SummaryPDF reportData={reportData} blockHistory={blockHistory} />
            <View
              style={{
                flexDirection: 'row',
                paddingHorizontal: 8,
                width: '100%',
                gap: 8,
              }}
            >
              <View style={{ width: '50%', display: 'flex', gap: 8 }}>
                <ValidationInfoPDF reportData={reportData} />
              </View>
              <View style={{ width: '50%' }}>
                <FileDetailsPDF reportData={reportData} />
              </View>
            </View>
            <View style={{ display: 'flex', gap: 8, padding: 8 }}>
              <NftSectionPDF reportData={reportData} />
            </View>
            {reportData.VALID === 1 && (
              <View
                style={{
                  display: 'flex',
                  gap: 8,
                  paddingHorizontal: 8,
                }}
              >
                <BlockDetailsPDF reportData={reportData} blockHistory={blockHistory} />
              </View>
            )}
          </Page>
        </>
      )}
    </Document>
  );
};

export default DocumentPDF;
